import * as Ct from "ldlj"
import { useIntl } from "react-intl"
import { AccountRules } from "../../store/ducks/bank.ducks"
import { RuleCreateParts } from "./RuleCreateParts"

/* eslint-disable camelcase */

interface CreateOrEditRuleProps {
  isDisplayed: boolean
  onClose: () => void
  rulesLength: number
  createOrEdit: "create" | "edit"
  ruleToEdit: AccountRules | null
}
export const CreateOrEditRuleModal = ({
  isDisplayed,
  onClose,
  rulesLength,
  createOrEdit,
  ruleToEdit,
}: CreateOrEditRuleProps) => {
  const intl = useIntl()

  return (
    <Ct.Modal
      isDisplayed={isDisplayed}
      onClose={() => {
        onClose()
      }}
      left="50%"
      right="50%"
      top="calc(50vh - 55rem)"
    >
      <Ct.Card width={"136rem"}>
        <Ct.CloseCross onClick={onClose} />
        <Ct.Spacer height={4} />
        <Ct.Title
          text={intl.formatMessage({
            id: `bank-management.rules.${createOrEdit}-rule`,
          })}
          size={7}
        />
        <Ct.Spacer height={4} />
        <Ct.Separator size="full" />
        <Ct.Spacer height={4} />

        <RuleCreateParts
          isDisplayed={isDisplayed}
          onClose={onClose}
          rulesLength={rulesLength}
          createOrEdit={createOrEdit}
          ruleToEdit={ruleToEdit}
          from={"rules"}
          createForOneTransaction={null}
        />
      </Ct.Card>
    </Ct.Modal>
  )
}
